import SuggestedIngredients from './SuggestedIngredients'

export default SuggestedIngredients
